<template>
    <div :class="`comment_item comment_item_${item.uid}`">
        <div class="flex items-center justify-between">
            <div class="flex items-center">
                <!-- <vs-avatar
                    v-if="item.creator.avatar"
                    class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white"
                    :src="item.creator.avatar"
                />
                <vs-avatar
                    v-else
                    class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white"
                    :text="avatarText"
                ></vs-avatar> -->
                <!-- <div>
                    <div class="lg:flex comment_user">
                        <h5 class="text-sm lg:text-base">{{ userName }}</h5>
                        <div
                            class="text-xs lg:pl-2 font-light lg:text-sm"
                            v-if="relatedItem && answerTo"
                        >
                            {{ $t("answer_for") }}:
                            {{ relatedItem.creator['last_name_' + $i18n.locale] }}
                            {{ relatedItem.creator['first_name_' + $i18n.locale] }}
                        </div>
                    </div>
                    <div class="text-xs font-light lg:text-sm">
                        {{ createdDate }}
                    </div>
                </div> -->
                <profile
                    :avatar="item.creator.avatar"
                    :profile="item.creator"
                    :subtitle="createdDate"
                />
            </div>
            <vs-dropdown
                class="cursor-pointer"
                v-if="item.creator.uid == user.profileId"
                vs-trigger-click
            >
                <a class="flex items-center text-dark" href="#">
                    <feather-icon
                        icon="MoreHorizontalIcon"
                        svg-classes="h-5 w-5"
                    />
                </a>
                <vs-dropdown-menu>
                    <vs-dropdown-item
                        class="text-danger"
                        @click="removeComment"
                    >
                        {{ $t("remove") }}
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>
        <div class="comment_body mt-3">
            {{ item.text }}
        </div>
        <div v-if="!showCommentForm && answerOn" class="mt-2 flex items-center">
            <span class="text-primary cursor-pointer" @click="toggleInput()">{{
                $t("to_answer")
            }}</span>
            <template v-if="!loaded && item.comments_related">
                <span class="mx-3 text-dark">·</span>
                <span
                    @click="getHandler()"
                    class="cursor-pointer text-primary flex items-center"
                >
                    <feather-icon
                        class="mr-1"
                        icon="CornerDownRightIcon"
                        svg-classes="h-4 w-4"
                    />
                    {{ answerText }}
                </span>
            </template>
            <template v-if="loaded && item.comments_related && treeHideButton">
                <span class="mx-3 text-dark">·</span>
                <span
                    @click="answerHide()"
                    class="cursor-pointer hide_text flex items-center"
                >
                    <feather-icon
                        class="mr-1"
                        icon="ChevronUpIcon"
                        svg-classes="h-4 w-4"
                    />
                    {{ $t("hide_replies") }}
                </span>
            </template>
        </div>

        <div v-if="showCommentForm && answerOn" class="mt-2 mb-3">
            <div class="mb-2 cursor-pointer" @click="toggleInput()">
                <div class="flex items-center text-sm">
                    <span class="text-danger mr-1">{{ $t("to_answer") }}</span>
                    <feather-icon icon="XIcon" svg-classes="h-3 w-3" />
                </div>
            </div>
            <CommentInput
                @loadUpdate="loadUpdate"
                @hideInput="toggleInput"
                @updateAnswerCount="updateAnswerCount"
                :commentKey="item.uid"
                :parentElem="item"
                :mode="mode"
                type="child"
            />
        </div>

        <div
            :class="['pt-3 child_comments', treeType]"
            v-if="loaded || updated"
        >
            <template v-if="removeUpdate">
                <div
                    class="mb-4 lg:mb-6"
                    v-for="childItem in item.child"
                    :key="`comment_${childItem.uid}`"
                >
                    <component
                        @loadUpdate="loadUpdate"
                        :treeHideButton="treeHideButton"
                        :tree="tree"
                        :onDelete="onDelete"
                        :answerOn="answerOn"
                        :answerTo="answerTo"
                        @handlerRemoveUpdate="handlerRemoveUpdate"
                        v-bind:is="thisComponent"
                        :mode="mode"
                        :item="childItem"
                        :relatedItem="item"

                         v-on:showAnserInput="toggleChildShowInput($event)"
                    />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
const declOfNum = (n, text_forms) => {
    n = Math.abs(n) % 100;
    var n1 = n % 10;
    if (n > 10 && n < 20) {
        return text_forms[2];
    }
    if (n1 > 1 && n1 < 5) {
        return text_forms[1];
    }
    if (n1 === 1) {
        return text_forms[0];
    }
    return text_forms[2];
};

import CommentInput from "./CommentInput";
import CommentItem from "./CommentItem";
import { mapActions } from "vuex";
import profile from "../Profile";

export default {
    props: {
        item: Object,
        relatedItem: {
            type: Object,
            default: null,
        },
        mode: {
            type: String,
            default: "big",
        },
        commentKey: {
            type: String,
            default: "",
        },
        previewMode: {
            type: Boolean,
            default: false,
        },
        previewSize: {
            type: Number,
            default: 2,
        },
        commentsLength: {
            type: Number,
            default: 0,
        },
        treeHideButton: {
            type: Boolean,
            default: true,
        },
        tree: {
            type: Boolean,
            default: true,
        },
        onDelete: {
            type: Boolean,
            default: true,
        },
        answerTo: {
            type: Boolean,
            default: true,
        },
        answerOn: {
            type: Boolean,
            default: true,
        },
        clubCommentDelete: { // ДЛя удаления комментаринв основателю в студ клубе 
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showCommentForm: false,
            loaded: false,
            updated: false,
            removeUpdate: true,
            answerCount: this.item.comments_related,
            answerAddedText: "",
        };
    },
    components: {
        CommentInput,
        CommentItem,
        profile,
    },
    computed: {
        treeType() {
            // Режим комментариев, деревом или списком
            if (this.tree) return "pl-3 lg:pl-8";
            else return "";
        },
        deleteRoles(){
            if(this.onDelete){ 
                if((this.user.profileId === this.item.creator.profileId) 
            || (this.user.role.is_org_admin)
             || (!this.clubCommentDelete && this.user.role.is_columnist)
             || (this.clubCommentDelete)){
                    return true
                }
            }
            return false
        },
        answerText() {
            // Меняем строку под количество ответов
            return (
                this.answerCount +
                this.answerAddedText +
                " " +
                declOfNum(this.answerCount, [
                    this.$t("answer"),
                    this.$t("answer2"),
                    this.$t("replies"),
                ])
            );
        },
        thisComponent() {
            // Получаем этот же компонент для дерева
            return () => import(`@/widgets/CommentBox/CommentItem`);
        },
        user() {
            return this.$store.state.user.user;
        },
        userName() {
            // Формируем полное имя пользователя
            return `${ this.item.creator["last_name_" + this.$i18n.locale] } ${
                this.item.creator["first_name_" + this.$i18n.locale]
            }`;
        },
        avatarText() {
            // Возвращяем инициалы пользователя
            let title,
                text = this.userName;

            const textAr = text.split(" ");
            if (textAr.length) {
                const newTitle = [];
                textAr.forEach((item) => {
                    newTitle.push(item.substr(0, 1).toUpperCase());
                });
                title = newTitle.join("");
            } else title = text.substr(0, 1);
            return title;
        },
        createdDate() {
            // Меняем формат даты
            return this.$moment(this.item.created).format("DD.MM.YYYY в HH:mm");
        },
    },
    methods: {
        ...mapActions({
            getComment: "comment/getChildComment",
            getCommentUpdate: "comment/getComment",
            deleteComment: "comment/deleteComment",
        }),
        answerHide() {
            this.loaded = false;
            this.updated = false;
        },
        async removeComment() {
            // Удаление комментария
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: `.comment_item_${ this.item.uid }`,
                        scale: 0.6,
                    });
                });
                const res = await this.deleteComment({
                    item: this.item,
                    relatedItem: this.relatedItem,
                    key: this.commentKey,
                });

                this.$vs.notify({
                    text: this.$t("comment_has_been_deleted"),
                    color: "success",
                });

                if (res.update) {
                    this.$emit("handlerRemoveUpdate", false);
                    this.$emit("handlerRemoveUpdate", true);
                } else {
                    if (
                        this.previewMode &&
                        this.commentsLength <= this.previewSize
                    ) {
                        // Запрашиваем комменты
                        this.previevModeUpdate(this.commentKey);
                    }
                }
            } catch (e) {
            } finally {
                this.$vs.loading.close(
                    `.comment_item_${ this.item.uid } > .con-vs-loading`
                );
            }
        },
        async previevModeUpdate(uid, type = "set", page = 1) {
            // Запрашиваем страницу
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: `.comment_box_${ this.commentKey }`,
                        scale: 0.6,
                    });
                });
                await this.getCommentUpdate({
                    uid,
                    page,
                    type,
                    page_size: this.previewSize,
                    previewMode: this.previewMode,
                    previewSize: this.previewSize,
                });
            } catch (e) {
                this.$vs.notify({
                    text: this.$t("error"),
                    color: "danger",
                });
            } finally {
                this.$vs.loading.close(
                    `.comment_box_${ this.commentKey } > .con-vs-loading`
                );
            }
        },
        updateAnswerCount() {
            // Добавляем к строке количества ответов + при добавлении нового ответа
            if (this.answerCount) this.answerAddedText = "+";
        },
        loadUpdate(val) {
            // Перерендер списка
            this.updated = val;
        },
        handlerRemoveUpdate(val) {
            // Второй перерендер списка
            this.removeUpdate = val;
        },
        toggleChildShowInput(event){
            this.$emit('showAnserInput',event)
        },
        toggleInput() {
            // Показать/Скрыть форму комментария
            this.showCommentForm = !this.showCommentForm;
            this.$emit('showAnserInput',this.showCommentForm)
        },
        async getHandler() {
            // Получить список дочерних комментариев
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: `.comment_item_${ this.item.uid }`,
                        scale: 0.6,
                    });
                });
                await this.getComment(this.item);
            } catch (e) {
            } finally {
                this.$vs.loading.close(
                    `.comment_item_${ this.item.uid } > .con-vs-loading`
                );

                // Показываем список
                this.loaded = true;
                //this.updated = true
            }
        },
    },
};
</script>

<style lang="scss">
.comment_item {
    position: relative;
    .con-vs-loading {
        position: absolute;
    }
}
</style>

<style lang="scss" scoped>
.hide_text {
    color: #909090;
}
.comment_body {
    word-break: break-word;
}
.comment_user {
    align-items: end;
}
</style>
